import { FormGroup } from '@angular/forms';
import { B3SelectItem } from 'src/app/shared/models/b3-select-item.model';
import { ParticipantCities } from 'src/app/shared/interfaces/address';
import { detectDocumentType } from 'src/app/helpers/utils/cpf-cnpj.util';

export class RegisterFormSharedUtil {
  static onBlurDate(form: FormGroup, date: Date, inputId: string, today: Date, minDate: Date) {
    form.get(inputId)?.setValue(date);
    const isInvalid = date > today || date < minDate;
    return { dateFlag: false, isInvalid };
  }

  static checkHasError(form: FormGroup, fieldName: string, errorCode?: string): boolean {
    const field = form.get(fieldName);
    if (!field || !field.touched) return false;
    return errorCode ? field.hasError(errorCode) : field.invalid;
  }

  static calculateAvailableHectares(form: FormGroup) {
    const totalRaw = form.get('totalHectares')?.value;
    const carbonRaw = form.get('carbonGenerationHectares')?.value;
    const total = Number(totalRaw) || 0;
    const carbon = Number(carbonRaw) || 0;
    const hasTotalInput = String(totalRaw ?? '').trim() !== '';

    if (hasTotalInput && carbon > total) {
      form.get('carbonGenerationHectares')?.setErrors({ exceedsTotal: true });
    } else {
      form.get('carbonGenerationHectares')?.setErrors(null);
    }

    if (!hasTotalInput) {
      form.get('availableHectares')?.setValue('', { emitEvent: false });
      return;
    }

    form.get('availableHectares')?.setValue(total - carbon, { emitEvent: false });
  }

  static mapCitiesToSelect(cities: ParticipantCities[]): B3SelectItem[] {
    return cities.map(city => ({
      inputId: city?.cityCode || '',
      label: city?.cityName || '',
      data: city?.cityName || ''
    }));
  }

  static filterCities(list: B3SelectItem[], q: string): B3SelectItem[] {
    const s = q?.toLowerCase() || '';
    return list.filter(c => (c.label || '').toLowerCase().includes(s));
  }

  static maskForDoc(value: string): string {
    const t = detectDocumentType(value);
    if (t === 'CPF') return '000.000.000-00';
    if (t === 'CNPJ') return 'AA.AAA.AAA/AAAA-AA';
    return '';
  }

  static normalizeUF(ufCtrl: any): string {
    return typeof ufCtrl === 'string' ? ufCtrl : (ufCtrl?.inputId ?? ufCtrl ?? '');
  }

  static normalizeCityName(cityCtrl: any): string {
    return typeof cityCtrl === 'string' ? cityCtrl : (cityCtrl?.label ?? cityCtrl?.data ?? '');
  }

  static normalizeLocations(rawLocations: any[], uf: string, cityName: string): any[] {
    if (!Array.isArray(rawLocations)) return [];
    return rawLocations.map((l: any) => {
      const m = typeof l?.municipality === 'string' ? l.municipality : cityName;
      const luf = typeof l?.uf === 'string' ? l.uf : (l?.uf?.inputId ?? uf);
      return { ...l, uf: luf, municipality: m };
    });
  }
}